import React from 'react';
import { cn } from '@/utils';

type Props = {
  title?: string;
  titleClassName?: string;
  description: string;
  asideAction?: JSX.Element;
  descriptionContainerClassName?: string;
};
const TitleSection = ({
  title,
  description,
  titleClassName,
  asideAction,
  descriptionContainerClassName,
}: Props) => {
  return (
    <>
      {title && (
        <div className={cn('mb-[5px] flex flex-1 border-b-[1px] border-b-silver', titleClassName)}>
          <label className="headline-h4 text-primary">{title}</label>
          {asideAction}
        </div>
      )}
      <div className={descriptionContainerClassName}>
        <p className="body-text1 text-tundora">{description}</p>
      </div>
    </>
  );
};

export default TitleSection;
